const IN_TO_MM = 25.4;
const CSS_DPI = 96;

/** mm → browser CSS px (96 dpi reference). */
export function mmToCssPx(mm) {
  return (mm / IN_TO_MM) * CSS_DPI;
}

/** inches → browser CSS px. */
export function inToCssPx(inches) {
  return inches * CSS_DPI;
}

/**
 * Fit base design canvas into target box; preserve aspect ratio.
 * @returns {{ scale: number, scaledWidthPx: number, scaledHeightPx: number }}
 */
export function computeFitScale(baseW, baseH, targetW, targetH) {
  if (!baseW || !baseH || !targetW || !targetH) {
    return { scale: 1, scaledWidthPx: baseW, scaledHeightPx: baseH };
  }
  const scale = Math.min(targetW / baseW, targetH / baseH);
  return {
    scale,
    scaledWidthPx: baseW * scale,
    scaledHeightPx: baseH * scale,
  };
}

/**
 * Wrap card HTML in CardPreview-style fit container.
 * Renders full template, scales proportionally into target area, centers by default.
 */
export function wrapScaledHtml(html, baseW, baseH, targetW, targetH, { center = true } = {}) {
  const { scale, scaledWidthPx, scaledHeightPx } = computeFitScale(baseW, baseH, targetW, targetH);
  const inner = `<div class="card-scaled-inner" style="width:${baseW}px;height:${baseH}px;transform:scale(${scale});transform-origin:top left;">
    ${html}
  </div>`;

  if (!center) {
    return `<div class="card-scaled-outer" style="width:${scaledWidthPx}px;height:${scaledHeightPx}px;overflow:hidden;">
      ${inner}
    </div>`;
  }

  return `<div class="card-scaled-outer" style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;overflow:visible;">
    <div style="width:${scaledWidthPx}px;height:${scaledHeightPx}px;overflow:hidden;flex-shrink:0;">
      ${inner}
    </div>
  </div>`;
}

/** Fit card HTML into mm-sized slot. */
export function wrapCardHtmlScaled(html, cardWidthMm, cardHeightMm, baseWidthPx, baseHeightPx) {
  const targetW = mmToCssPx(cardWidthMm);
  const targetH = mmToCssPx(cardHeightMm);
  return wrapScaledHtml(html, baseWidthPx, baseHeightPx, targetW, targetH, { center: true });
}
